// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1CMEp","productName":"Table_productName__2WoMO"};